module.exports = __webpack_public_path__ + "static/media/rsa.67c33645.svg";